import axios from '../../axios'

/**
 * 1.2.1 民族信息列表
 * @param pageNo
 * @param pageSize
 * @returns {Promise | Promise<unknown>}
 */
export const page = (pageNo, pageSize) => {
  return axios({
    url: '/clubExamines/nation/page/' + pageNo + '/' + pageSize,
    method: 'GET'
  })
}

/**
 * 1.2.2  添加民族
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const add = data => {
  return axios({
    url: '/clubExamines/nation/add',
    method: 'POST',
    data
  })
}

/**
 * 1.2.3  修改民族
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const update = data => {
  return axios({
    url: '/clubExamines/nation/update',
    method: 'PUT',
    data
  })
}

/**
 * 1.2.4  删除民族
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const del = (id, code) => {
  return axios({
    url: '/clubExamines/nation/del/' + id + '/' + code,
    method: 'DELETE'
  })
}

/**
 * 1.2.5  导入民族信息
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const importNation = (fileFormData) => {
  return axios({
    url: '/clubExamines/nation/import',
    method: 'POST',
    data: fileFormData
  })
}

/**
 * 1.2.6  查询所有民族信息
 * @returns {Promise | Promise<unknown>}
 */
export const getAll = () => {
  return axios({
    url: '/clubExamines/nation/getAll',
    method: 'GET'
  })
}




// WEBPACK FOOTER //
// ./src/http/modules/examines/nation.js